import React from 'react'
import {useEffect,useState,useCallback} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'
import { ToastContainer, toast } from 'react-toastify';
import { BASE_URL } from '../Config/Base';
import Select from "react-select";
import _ from 'lodash'
import {CircleLoader} from 'react-spinners';


const FoundAssignMain = () => {

  const token = JSON.parse(localStorage.getItem('usertoken'));
  const [allusers, setAllusers] = useState([]);
  const [name,setName]= useState([{}])
  const[details, setDetails] =useState([])
  const[Assigndetails, setAssigndetails] =useState([])

  const pageSize = 3;

  const [paginatedPosts, setpaginatedPosts] = useState();
  // const [currentPage, setcurrentPage] = useState(1);

  useEffect(() => {
    getAssignUser()
        getmethod();
       
  }, [])

  function getmethod(){
  console.log("Token", token)
  fetch(`${BASE_URL}/Foundation/Getfoundationusers`, {

    method: 'GET',

    headers: {

      "Content-type": "application/json",

      "Accept": "application/json",

      "Authorization": "Bearer " + `${token}`,

      "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

    },

    //body:JSON.stringify(data)

  }).then(response => response.json())

    .then(data => {
      console.log("Data", data)
      setAllusers(data);
      // setName(data);
        }
    );

console.log("check",allusers)
      }


      function getAssignUser(){
  
        fetch(`${BASE_URL}/Foundation/GetAssignUsers`, {
          method:'GET',
          headers : {
    
            "Content-type": "application/json",
    
            "Accept": "application/json",
      
            "Authorization": "Bearer " + `${token}`,
      
            "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
          },
    
          //body:JSON.stringify(data)
    
        }).then(response => response.json())
        .then(data => {
          console.log("Data",data)
          setAssigndetails(data);
           setpaginatedPosts(_(data).slice(0).take(pageSize).value());
          //localStorage.setItem("SectionData", JSON.stringify(data));
          localStorage.setItem("paginationDataAssign", JSON.stringify(data));
        });
        console.log("check",allusers)
      }
    
      // const pageCount = Assigndetails? Math.ceil(Assigndetails.length/pageSize) :0;
      // // if (pageCount === 1)
      // // return null;
      
      // const pages = _.range(1, pageCount+1)
      
      // const pagination =(pageNo)=>{
      // setcurrentPage(pageNo);
      // const startIndex = (pageNo - 1) * pageSize;
      // const paginatedPost = _(Assigndetails).slice(startIndex).take(pageSize).value();
      // setpaginatedPosts(paginatedPost)
      // }

      
  const [selectedOptions, setSelectedOptions] = useState();

 
  const optionList = [
    { value: "Home", label: "Home" },
    { value: "Who we Are", label: "Who we Are" },
    { value: "Journey and Stories", label: "Journey and Stories" },
    { value: "Differentiators", label: "Differentiators" },
    { value: "Contributors", label: "Contributors" }
  ];

  function handleSelect(data) {
    setSelectedOptions(data);
  }


// AssignSection
function AssignSection(){
 
    var Id = document.getElementById('UserName').value
 
   let assign = selectedOptions.map((item) => item.label);
   console.log(assign)
   //const allFruits = Object.assign({}, ...assign);
   let section = assign.toString();

   const token = JSON.parse(localStorage.getItem('usertoken'));

  // console.log(section);
  
  const body ={
    id:Id,  
    section:section,
    assignStatus:0
  }
  axios({

    method:"POST",
    url:`${BASE_URL}/Foundation/AssignSection`,
    data:body,
    headers: {
      "Content-Type" : "application/json",

      "Authorization": "Bearer " + `${token}`
    }

})
.then((response) =>{
  console.log(response.data);
 
 
  document.getElementById("AssignTbl").reset();
  setSelectedOptions("");
  alert("Task Assigned Successfully !");
  // toast.success("Task Assigned Successfully !", {
  //   position: "top-center",
  //   autoClose: 3200,
  //   hideProgressBar: false,
  //   closeOnClick: true,
  //   pauseOnHover: true,
  //   draggable: true,
  //   progress: undefined,
  //   className: 'toast-message'
  //   });

    setTimeout(()=>{
    getAssignUser();
    },3000)
 })
 .catch(error => {
 console.log(error);
alert("Failed to Assigned !")

  })
  }


  function ConfirmDelete(Id){
     
    getParticularDetails(Id)
    document.getElementById("modalDeleteForm").style.display = "block";
    
  
  }

 //delete btn func
 function DeleteStatus(Id,userName){

  // let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
   const body ={
    id: Id
  }
   console.log(body)
    axios({
   
    method:"POST",
    //url: `${BASE_URL}/Tc/DeleteStatus`,
   url:`${BASE_URL}/Foundation/DeleteAssignUser`,
   data:body,
   headers: {
   "Content-Type" : "application/json",
   "Authorization": "Bearer " + `${token}`
   }

   
  
    })
    .then((response) =>{
    console.log(response.data);
    //window.location.reload();
    
    if(response.data.status === "Success"){
      alert(userName+""+"-"+"Deleted Successfully!")
      // toast.success(userName+""+"-"+"Deleted Successfully!");

        closedelForm()
        getmethod()
        getAssignUser()
        // setcurrentPage(1);
        // setTimeout(() => {        
        //    window.location.reload();
        // }, 5000);
     
    }

    })
 
    } 

    function getParticularDetails(Id){
   
      // let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
      
   
    
     const body ={
      
      id:Id
    
     }
     console.log(body);
    
    
      axios({          
         method: "POST", 
         //url: `${BASE_URL}/Tc/EditSection`,      
         url: `${BASE_URL}/Foundation/GetParticularAssignUser`,
         data:body,
         headers: {             
           'Content-Type': 'application/json' , 
           "Authorization": "Bearer " + `${token}`    
         }
       
       })
       .then((response) =>{
        console.log(response.data);
        setDetails(response.data)
    
         }) 
    
    } 


  function closedelForm(){

   document.getElementById("modalDeleteForm").style.display = "none";
 
 }

 function Cancel(){

  document.getElementById("modalDeleteForm").style.display = "none";      
     
}
    

const LEFT_PAGE = "LEFT";
const RIGHT_PAGE = "RIGHT";
const range = (from, to, step = 1) => {
  let i = from;
  const range = [];

  while (i <= to) {
    range.push(i);
    i += step;
  }

  return range;
};
 const [currentPage, setCurrentPage] = useState(1);

let data = localStorage.getItem("paginationDataAssign")
let transdata =  JSON.parse(data);
let NUM_OF_RECORDS = transdata.length;
let LIMIT = 5;

const onPageChanged = useCallback(

  (event, page) => {
    event.preventDefault();
    setCurrentPage(page);
  },
  [setCurrentPage]
  
);


const currentData = transdata.slice(
  (currentPage - 1) * LIMIT,
  (currentPage - 1) * LIMIT + LIMIT
);

const Paginations = (props) => {
  const {
    totalRecords,
    pageLimit,
    pageNeighbours,
    onPageChanged,
    currentPage
  } = props;
  const [totalPages, setTotalPages] = useState(0);
  useEffect(() => {
    setTotalPages(Math.ceil(totalRecords / pageLimit));
  }, [setTotalPages]);

  const fetchPageNumbers = () => {
    const totalNumbers = pageNeighbours * 1 + 0;
    console.log(totalNumbers)
    console.log(pageNeighbours)
    const totalBlocks = totalNumbers + 2;
    console.log(totalBlocks)

    if (totalPages > totalBlocks) {
      const startPage = Math.max(2, currentPage - pageNeighbours);
      const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);

      let pages = range(startPage, endPage);

      const hasLeftSpill = startPage > 2;
      const hasRightSpill = totalPages - endPage > 1;
      const spillOffset = totalNumbers - (pages.length + 1);

      switch (true) {
        case hasLeftSpill && !hasRightSpill: {
          const extraPages = range(startPage - spillOffset, startPage - 1);
          pages = [LEFT_PAGE, ...extraPages, ...pages];
          break;
        }
        case hasLeftSpill && hasRightSpill:
        default: {
          pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
          break;
        }
      }
      return [1, ...pages, totalPages];
    }
    return range(1, totalPages);
    
  };


  const pages = fetchPageNumbers() || [];
  return (
    <nav aria-label="Countries Pagination" id='foundnavpag'>
      <ul className="pagination">
        {pages.map((page, index) => {
          if (page === LEFT_PAGE)
            return (
              <li key={index} className="page-item">
                <a
                  href="/"
                  className="page-link"
                  aria-label="Previous"
                  onClick={(e) => onPageChanged(e, pageNeighbours * 2 - 1)}
                >
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
            );

          if (page === RIGHT_PAGE)
            return (
              <li key={index} className="page-item">
                <a
                  className="page-link"
                  href="/"
                  aria-label="Next"
                  onClick={(e) => onPageChanged(e, pageNeighbours * 2 + 1)}
                >
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            );

          return (
            <li
              key={index}
              className={`page-item${currentPage === page ? " active" : ""}`}
            >
              <a
                className="page-link"
                href="/"
                onClick={(e) => onPageChanged(e, page)}
              >
                {page}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
     

  return (
    
    /*----top bar----*/

    <>
    <div className='foundation-addmain'>
      
    <ToastContainer id="toast"
          position="top-center"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          /> 

    <div className="foundation-addgrid-layout">
    <div className="foundation-addmain-top">
        <div className='foundation-addmain-back'>
           <Link to='/Kdp Foundation '><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
        </div> 
           <span>Assign</span>
 

     </div>
 </div>
 

 <div className='foundation-Assign-table'>
<div class="foundation-Assign-table-responsive">
<form id="AssignTbl">


 <table class="Assign-Table-found">
  <thead>
    <tr>
     
      <th>UserName</th>
      <th>Section</th>
      <th>Assign</th>

    </tr>
  </thead>
  <tbody>
<tr>
      
      <td>
       
      <select id='UserName'>
        <option value="UserNames">UserNames</option>
      {allusers.map((e)=>{
    return  <option id='namelist'  value={e.id} >{e.userName}</option>  })} 
       </select>

      </td>

  <td>          
           
  <div> <Select
  className="dropdown"
  options={optionList}
  placeholder="Select Section"
  value={selectedOptions}
  onChange={handleSelect}
  isSearchable={true}
  isMulti
  isClearable
  />
  </div>

 </td>

<td className='text-center'>
 
<button className='foundation-Assign-button' onClick={AssignSection}> Assign </button>
</td>
</tr>


    
  </tbody>
</table>



</form>
</div>
</div>


<div className='foundation-Assigndisplay-table'>
<div class="foundation-Assigndisplay-table-responsive">
    
{/* {
  !paginatedPosts ? (" "):( */}
    <table className="Assigndisplay-Table-found">

      <thead>
        <tr>
          <th>UserName</th>
          <th>Section</th>
          <th>Action</th>
        </tr>
      </thead>

      <tbody>

      {currentData.map((e)=>{
        return<tr>
            <td>{e.userName}</td>
            <td>{e.section}</td>
            <td id='ActionData'>

     <i className="fa-solid fa-trash" id='FoundDelicon' onClick={()=>ConfirmDelete(e.id)}></i></td>

      
      </tr>
      })}

      </tbody>
      
      </table >
       {/* )} */}


<br></br>

{transdata.length<=5? null:<div>{

!paginatedPosts ? (""):(  <Paginations
            totalRecords={NUM_OF_RECORDS}
            pageLimit={LIMIT}
            pageNeighbours={1}
            onPageChanged={onPageChanged}
            currentPage={currentPage}
          /> 
          )}
          </div>
}
{/*   
  <nav>
   <ul className='pagination'>
     {
       pages.map((page)=>(
         <li className={
           page === currentPage ? "page-item active" : "page-item"
         }>
           <p className='page-link'
           onClick={()=>pagination(page)}
           >
           {page}
           </p>
           </li>
       ))
     }
      

   </ul>
 </nav>  */}


      </div>
      </div>

   {/* DeletePopup */}

 <div className="foundation-pop-fade" id="modalDeleteForm" tabindex="-1" role="dialog">
 {details.map((e)=>{ 
   return<div className="modal-dialog" role="document">
      <div className="modal-content"  style={{marginTop:"280px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">! Warning</h4>
        <button type="button" className="close" onClick={closedelForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    <form id='form'>

     <div className="modal-body mx-3">

        <div className="md-form mb-0">
            <div className='text-center'>
          <h5>Are you sure want to Delete?</h5>
          </div>
        </div>

      </div>

       <div className="modal-footer d-flex justify-content-center">
       <button className="foundation-deleteuser-button"  onClick={()=>DeleteStatus(e.id,e.userName)} type='submit'>Delete</button>
        <button className="foundation-deleteuser-button"  onClick={Cancel} type='submit'>Cancel</button>
       </div>
       </form>
      
     </div>
    </div>
    })} 
</div>
  
</div>

 </>
 
  )
}

export default FoundAssignMain